import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import axios from "axios";
import { API } from "@/lib/api";
import { useSeo } from "@/lib/useSeo";

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    axios.get(`${API}/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  useSeo({
    title: post ? post.title : "Article",
    description: post ? post.excerpt : "",
    path: `/blog/${slug}`,
    jsonLd: post ? { "@context": "https://schema.org", "@type": "BlogPosting", headline: post.title, datePublished: post.date, description: post.excerpt } : null,
  });

  if (notFound) return <div className="mx-auto max-w-2xl px-4 py-24 text-center"><h1 className="font-heading text-3xl font-bold">Post not found</h1><Link to="/blog" className="mt-4 inline-block text-primary hover:underline">← Back to blog</Link></div>;
  if (!post) return <div className="mx-auto max-w-3xl px-4 py-24 text-center text-muted-foreground">Loading…</div>;

  return (
    <article className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8 animate-fade-up">
      <nav className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <Link to="/" className="hover:text-foreground">Home</Link><ChevronRight className="h-3 w-3" />
        <Link to="/blog" className="hover:text-foreground">Blog</Link><ChevronRight className="h-3 w-3" />
        <span className="font-medium text-foreground">{post.title}</span>
      </nav>
      <span className="mt-6 inline-block overline text-primary">{post.tag} · {post.date}</span>
      <h1 className="mt-2 font-heading text-4xl font-bold tracking-tight">{post.title}</h1>
      <div className="prose mt-8 max-w-none">
        {post.content.split("\n\n").map((para, i) => (
          <p key={i} className="mb-4 whitespace-pre-wrap leading-relaxed text-foreground/90">{para}</p>
        ))}
      </div>
    </article>
  );
};

export default BlogPost;
